<template>
  <li class="nav-item">
    <a
      v-bind="$attrs"
      class="nav-link"
      :class="{
        active: active,
        disabled: disabled
      }"
      :aria-disabled="disabled ? 'true' : null"
      :tabindex="disabled ? '-1' : null"
      href="#"
      target="_self"
      @click="onClick"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: 'BNavItem',
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    onClick(e) {
      e.preventDefault()
      this.$emit('click', e)
    }
  }
}
</script>

